/**
 * Kanonik site kökü. `metadataBase`, OG URL’leri, sitemap ve robots için kullanılır.
 *
 * **Önemli:** Değer mutlaka şema içermeli: `http://localhost:3000` veya `https://www.oravity.com`
 * (`localhost:3000` tek başına geçersizdir → Invalid URL).
 */
export function getSiteUrl(): string {
  const raw = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (!raw) {
    return "https://oravity.com";
  }

  let url = raw.replace(/\/$/, "");

  if (!/^https?:\/\//i.test(url)) {
    const host = url.split("/")[0] ?? url;
    const isLocal =
      host.startsWith("localhost") ||
      host.startsWith("127.") ||
      host === "[::1]";
    url = `${isLocal ? "http" : "https"}://${url}`;
  }

  try {
    const parsed = new URL(url);
    if (!parsed.hostname) throw new Error("missing host");
    return `${parsed.origin}`;
  } catch {
    return "https://oravity.com";
  }
}
